const typo = {
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '146%',
  color: '#23252F',
};

export const styles = {
  container: {
    padding: '24px',
    paddingTop: '0',
    marginTop: '12px',
    height: 'calc(100vh - 249px)',
    overflowY: 'auto',
    overflowX: 'hidden',

    '&.in-modal': {
      padding: '12px 0',
    },

    '&::-webkit-scrollbar': {
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },
    '&::-webkit-scrollbar-track': {
      background: '#fff',
      border: 'none',
      height: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
  tableContainer: {
    boxSizing: 'border-box',
    border: '1px solid #EDEFF7',
    borderRadius: '12px',
    backgroundColor: '#fff',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '11px',
      height: '11px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
    },
  },
  tableHeadItem: {
    ...typo,
    fontWeight: '500',
    textAlign: 'left',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    padding: '14px 16px',
    borderRight: '1px solid #F3F4F9',
    borderBottom: '1px solid #F3F4F9',
    gap: '16px',
    alignItems: 'center',

    '&:last-child': {
      borderRight: '0',
    },
    '&.aligned-right': {
      textAlign: 'right',
    },
  },
  tableRow: {
    position: 'relative',

    '& .first': {
      zIndex: '2',
    },

    '&:hover .rowBackground': {
      border: '1px solid #4D6EF5',
    },

    '&:hover > .MuiTableCell-root': {
      background: '#FAFBFC',
    },

    '&:last-child': {
      '& .MuiTableCell-root': {
        borderBottom: 0,

        '& .rowBackground': {
          borderBottomLeftRadius: '12px',
          borderBottomRightRadius: '12px',
        },
      },
    },
  },
  tableCell: {
    ...typo,
    lineHeight: 1,
    padding: '0 16px',
    height: '48px',
    borderBottom: '1px solid #F3F4F9',
    borderRight: '1px solid #F3F4F9',
    whiteSpace: 'nowrap',

    '& .MuiTypography-root': {
      ...typo,
    },
    '&:last-child': {
      borderRight: 0,
    },
    '&.actions-wrapper': {
      width: '20px',
    },
  },
  nameWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    textDecoration: 'none',
    cursor: 'pointer',
    zIndex: 2,
  },
};
